import React from "react";
import Item from "./Item";

const Section = ({ Items }) => {
  return (
    <div className="help-guide-section">
      <div className="d-flex flex-wrap help-guide-section-wrap">
        {Items.map((hi, key) => (
          <div className="col help-guide-section-item-wrapper" key={key}>
            <Item {...hi} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Section;
